<template>
    <div>
        <v-container grid-list-xl fluid class="pt-0">
            <v-layout row wrap>
                <v-flex sm12>
                    <v-card>
                        <v-toolbar color="primary" dark flat>
                            <v-toolbar-title>
                                <v-icon medium>fa fa-check-square</v-icon>
                                Lista de Asistencias
                            </v-toolbar-title>

                            <v-divider class="mx-2" inset vertical></v-divider>

                            <v-flex sm3 class="pa-0" style="max-width: 200px">
                                <v-overflow-btn
                                    v-model="asistenciaGroupBy"
                                    label="Asistencias"
                                    :items="[{ text: 'Sin agrupar', value: '1' }, { text: 'Agrupados', value: '2' }]"
                                    hide-details
                                    class="pa-0"
                                    @change="loadAsistencia()"
                                >
                                </v-overflow-btn>
                            </v-flex>

                            <v-divider class="px-1" inset vertical></v-divider>

                            <v-spacer></v-spacer>

                            <v-toolbar-items>
                                <v-menu
                                    v-model="menufiltro"
                                    class="elevation-1"
                                    transition="slide-y-transition"
                                    top
                                    left
                                    min-width="500"
                                    max-height="500"
                                    :close-on-content-click="false"
                                >
                                    <template v-slot:activator="{ on: menu }">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on: tooltip }">
                                                <v-btn icon flat>
                                                    <v-badge color="orange" overlap>
                                                        <span slot="badge" v-if="activeFilters > 0">{{
                                                            activeFilters
                                                        }}</span>
                                                        <v-icon medium v-on="{ ...tooltip, ...menu }">fa-filter</v-icon>
                                                    </v-badge>
                                                </v-btn>
                                            </template>
                                            <span>Filtro Personalizado</span>
                                        </v-tooltip>
                                    </template>
                                    <custom-filter-asistencia
                                        v-if="menufiltro"
                                        :asistencia-group-by="asistenciaGroupBy"
                                        :internal-state="filterInternalState"
                                        @applyFilter="applyFilter"
                                    ></custom-filter-asistencia>
                                </v-menu>

                                <input ref="file" id="file" type="file" @change="onChange()" accept=".xls,.xlsx" />
                                <label for="file" class="v-btn--icon icon--upload">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon medium v-on="on">fa-upload</v-icon>
                                        </template>
                                        <span>Cargar asistencia</span>
                                    </v-tooltip>
                                </label>
                            </v-toolbar-items>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-data-table
                                :headers="
                                    asistenciaGroupBy !== '2' && asistenciaGroupBy !== '5'
                                        ? headersDatosSinAgrupar
                                        : headersDatosAgrupados
                                "
                                :loading="loading"
                                :pagination.sync="pagination"
                                :rows-per-page-items="pagination.rowsPerPageItems"
                                :total-items="totalItems"
                                :items="ASISTENCIAS"
                                class="elevation-1"
                                item-key="id"
                            >
                                <v-progress-linear v-slot:progress color="green" indeterminate></v-progress-linear>
                                <template slot="items" slot-scope="props">
                                    <tr>
                                        <template v-if="asistenciaGroupBy !== '2' && asistenciaGroupBy !== '5'">
                                            <td>{{ props.item.empleado ? props.item.empleado.nombre : "-" }}</td>
                                            <td>
                                                <v-icon :disabled="true">fa-calendar</v-icon>
                                                {{ props.item.fecha }}
                                            </td>
                                            <td>
                                                <v-icon small :disabled="true" v-if="props.item.entra"
                                                    >fa-clock-o</v-icon
                                                >
                                                {{ props.item.entra ? props.item.entra : "-" }}
                                            </td>
                                            <td>
                                                <v-icon :disabled="true" v-if="props.item.sale">fa-clock-o</v-icon>
                                                {{ props.item.sale ? props.item.sale : "-" }}
                                            </td>
                                            <td>
                                                {{ props.item.tarde ? props.item.tarde : "-" }}
                                                <div class="action-column">
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn
                                                                flat
                                                                icon
                                                                :color="props.item.justificacion ? 'success' : 'red'"
                                                                :disabled="loading || menuLocked"
                                                                @click="tardeJustificacionExpand(props)"
                                                            >
                                                                <v-icon medium v-on="on">fa-question</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Ver justificación</span>
                                                    </v-tooltip>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn
                                                                flat
                                                                icon
                                                                color="grey"
                                                                :loading="loadingEmpleadoAsistencias"
                                                                :disabled="
                                                                    loadingEmpleadoAsistencias || loading || menuLocked
                                                                "
                                                                @click="loadAsistenciaRecords(props.item)"
                                                            >
                                                                <v-icon medium v-on="on">fa-check-square</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Ver asistencias</span>
                                                    </v-tooltip>
                                                </div>
                                            </td>
                                        </template>
                                        <template v-else>
                                            <td>
                                                {{
                                                    props.item.nombre +
                                                        " " +
                                                        props.item.apellido_paterno +
                                                        " " +
                                                        props.item.apellido_materno
                                                }}
                                            </td>
                                            <td>
                                                {{
                                                    props.item.asistencia_totales
                                                        ? props.item.asistencia_totales.total_registros
                                                        : "-"
                                                }}
                                            </td>
                                            <td>
                                                {{
                                                    props.item.asistencia_totales
                                                        ? props.item.asistencia_totales.total_ausencias
                                                            ? props.item.asistencia_totales.total_ausencias +
                                                              " (justificadas: " +
                                                              props.item.asistencia_totales.ausencias_justificadas +
                                                              ")"
                                                            : "-"
                                                        : "-"
                                                }}
                                            </td>
                                            <td>
                                                {{
                                                    props.item.asistencia_totales
                                                        ? props.item.asistencia_totales.tiempo_retraso
                                                            ? props.item.asistencia_totales.tiempo_retraso
                                                            : "-"
                                                        : "-"
                                                }}
                                            </td>
                                        </template>
                                    </tr>
                                </template>
                                <template v-slot:expand="props">
                                    <v-card>
                                        <v-card-text class="py-0 pl-0">
                                            <v-container grid-list-xl fluid class="px-0 py-3">
                                                <v-layout row wrap>
                                                    <v-flex sm5 text-xs-right mr-2>Justificación:</v-flex>
                                                    <v-flex sm6
                                                        >{{
                                                            props.item.justificacion
                                                                ? props.item.justificacion.descripcion
                                                                : ""
                                                        }}
                                                        <v-tooltip bottom>
                                                            <template v-slot:activator="{ on }">
                                                                <v-icon
                                                                    small
                                                                    color="orange"
                                                                    v-on="on"
                                                                    @click="openForm(props.item)"
                                                                    >fa-edit</v-icon
                                                                >
                                                            </template>
                                                            <span>{{
                                                                props.item.justificacion
                                                                    ? "Modificar justificación"
                                                                    : "Agregar justificación"
                                                            }}</span>
                                                        </v-tooltip>
                                                    </v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-card-text>
                                    </v-card>
                                </template>
                                <template slot="no-data">
                                    <div style="text-align: center">
                                        No existen asistencias registradas en el sistema.
                                    </div>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>

        <justificacion-form v-if="showForm" :initial-item="asistenciaItem" @formCanceled="closeForm">
        </justificacion-form>

        <asistencia-time-line
            v-if="showAsistencia"
            @formCanceled="showAsistencia = false"
            :data="asistenciaData"
        ></asistencia-time-line>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import Util from "@/util"
import Vue from "vue"
const JustificacionForm = () =>
    import(/* webpackChunkName: "justificacion-form" */ "@/components/personal/empleado/justificacion-form/justificacion-form")
const AsistenciaTimeLine = () =>
    import(/* webpackChunkName: "asistencia-time-line" */ "@/components/widgets/asistencia-time-line/asistencia-time-line")
const CustomFilterAsistencia = () =>
    import(/* webpackChunkName: "filtro-asistencia" */ "@/components/widgets/custom-filter-asistencia/custom-filter-asistencia")

export default {
    components: { JustificacionForm, AsistenciaTimeLine, CustomFilterAsistencia },
    props: {
        estado: { type: String, default: null }
    },
    data: () => ({
        searchShow: false,
        loading: false,
        headersDatosSinAgrupar: [
            { text: "Empleado", value: "empleado_id" },
            { text: "Fecha", value: "fecha" },
            { text: "Entrada", value: "entra" },
            { text: "Salida", value: "sale" },
            { text: "Tarde", value: "tarde" }
        ],
        headersDatosAgrupados: [
            { text: "Empleado", value: "nombre" },
            { text: "Registros", value: "nombre", sort: false },
            { text: "Ausencias", value: "nombre", sort: false },
            { text: "Tiempo retraso", value: "nombre", sort: false }
        ],
        totalItems: 0,

        menuLocked: false,

        //agrupar las asistencias a cargar del back
        asistenciaGroupBy: "2",

        //filtro personalizado
        menufiltro: false,
        customFilter: null,
        activeFilters: 0,

        //archivo a importar
        file: "",

        //asistencia time line
        showAsistencia: false,
        asistenciaData: null,

        //formulario de justificaciones
        showForm: false,
        asistenciaItem: null,

        //para saber si ya se aplico el valor obtenido por las props
        estadoApplied: false,

        //cargando las asistencias de un empleado
        loadingEmpleadoAsistencias: false,

        //estado interno del filtro
        filterInternalState: null
    }),

    methods: {
        loadData(asistenciaGroupBy, customFilter) {
            this.loading = true
            this.$store
                .dispatch("LOAD_ASISTENCIAS", {
                    asistenciaGroupBy: asistenciaGroupBy,
                    customfilter: customFilter
                })
                .then(result => {
                    this.loading = false
                    this.totalItems = result
                })
        },

        loadAsistencia() {
            this.loadData(this.asistenciaGroupBy)
            this.customFilter = null
            this.activeFilters = 0
        },

        tardeJustificacionExpand(props) {
            props.expanded = !props.expanded
        },

        applyFilter(value) {
            if (value.activeFilters > 0) {
                this.menufiltro = false
                this.asistenciaGroupBy = "6"
                if (value.filterAsistenciaTotales) {
                    this.asistenciaGroupBy = "5"
                }
                this.customfilter = value.customFilter
                this.activeFilters = value.activeFilters
                this.loadData(this.asistenciaGroupBy, this.customfilter)
            } else {
                this.asistenciaGroupBy = "1"
                this.customfilter = null
                this.activeFilters = 0
                this.loadData(this.asistenciaGroupBy, this.customfilter)
                this.menufiltro = false
            }

            this.filterInternalState = {
                inputs: value.internalState.inputs,
                selectedCampos: value.internalState.selectedCampos
            }
        },

        onChange() {
            this.file = this.$refs.file.files[0]

            if (this.file !== "" && Util.validateFile(this.file.name, ["excel"])) {
                this.loading = true

                let asistencia = new FormData()
                asistencia.append("ImportAsistenciaForm[file]", this.file)
                this.$store.dispatch("ADD_ASISTENCIA", asistencia).then(response => {
                    if (response) {
                        this.loadData(this.asistenciaGroupBy)
                    }
                })
                this.loading = false
            } else {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Validación",
                    text:
                        "El archivo para importar las asistencia debe ser un documento Excel con extensiones xls o xlsx, inténtelo nuevamente"
                })
            }
        },

        loadAsistenciaRecords(item) {
            this.loadingEmpleadoAsistencias = true

            this.$store.commit("SET_EMPLEADO_ASISTENCIAS_PAG", { page: 1 })
            let empleado = this.$store.getters.EMPLEADO_ASISTENCIAS
            if (!empleado || empleado.id !== item.empleado_id) {
                //si no se ha cargado la asistencia del empleado solicitado
                this.$store.dispatch("LOAD_EMPLEADO_ASISTENCIA", item).then(() => {
                    if (
                        this.$store.getters.EMPLEADO_ASISTENCIAS.id === item.empleado_id &&
                        this.$store.getters.EMPLEADO_ASISTENCIAS.asistencia
                    ) {
                        this.$store.dispatch("LOAD_EMPLEADO_DETAILS_ASISTENCIA", item).then(result => {
                            if (result) {
                                this.loadingEmpleadoAsistencias = false
                                this.asistenciaData = {
                                    ...this.$store.getters.EMPLEADO_ASISTENCIAS,
                                    ...result
                                }
                                this.showAsistencia = true
                            }
                        })
                    }
                })
            } else {
                this.loadingEmpleadoAsistencias = false
                this.showAsistencia = true
            }
        },

        openForm(item) {
            this.asistenciaItem = item
            this.showForm = true
        },

        closeForm() {
            this.showForm = false
            this.asistenciaItem = null
        }
    },

    computed: {
        ...mapGetters(["ASISTENCIAS"]),

        pagination: {
            get: function() {
                return this.$store.getters.ASISTENCIAS_PAG
            },
            set: function(value) {
                this.$store.commit("SET_ASISTENCIAS_PAG", value)
            }
        }
    },

    watch: {
        pagination: {
            handler() {
                if (this.estado && !this.estadoApplied) {
                    //si se envio el valor estado por las props y no se ha aplicado, se aplica una sola vez
                    this.asistenciaGroupBy = this.estado
                    this.estadoApplied = true
                }
                this.loadData(this.asistenciaGroupBy, this.customfilter)
            },
            deep: true
        }
    }
}
</script>

<style scoped>
input[type="file"] {
    display: none;
}
.icon--upload {
    font-size: 13px;
    height: 35px;
    padding-left: 4px;
    padding-top: 1px;
    margin-top: 15px;
    cursor: pointer;
}
.icon--upload:hover {
    background-color: #61b865;
}
</style>
